import React, { useState } from 'react';
import { useEventListener } from './use-event-listener';

/**
 * Tracks whether the focus is inside provided element ref.
 *
 * @param elementRef The ref of a container element
 *
 * @returns Whether the focus is within provided element.
 */
export function useFocusWithin(
  elementRef: React.RefObject<HTMLElement | null>,
): boolean {
  const [focusWithin, setFocusWithin] = useState(false);

  useEventListener('focusin', (e) => {
    if (e.target && elementRef.current?.contains(e.target as Node)) {
      setFocusWithin(true);
    }
  });

  useEventListener('focusout', (e) => {
    if (
      !e.relatedTarget ||
      !elementRef.current?.contains(e.relatedTarget as Node)
    ) {
      setFocusWithin(false);
    }
  });

  return focusWithin;
}
